import { useQuery } from '@tanstack/react-query';

import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useUserContext } from '@/context/userContext/User.context.ts';

type Response = string[];

type Return = {
  isGetting: boolean;
  isSuccess: boolean;
  userTours: Response;
};

export const useGetUserTours = (): Return => {
  const { userToursApi } = useApiClient();
  const { userId } = useUserContext();

  const { data, isLoading, isSuccess } = useQuery<Response>({
    enabled: !!userId,
    queryFn: async () => {
      const { data } = await userToursApi.getUserTours(userId);
      return data.doneTours;
    },
    queryKey: [QueryKeyEnum.USERS.TOURS, userId],
  });

  return {
    isGetting: isLoading,
    isSuccess,
    userTours: data ?? [],
  };
};
